
import { Container, Card, Row, Col } from "react-bootstrap";
import './AmongTopSolar.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const AmongTopSolar = ({ topSolar = [], heading = "", subHeading = "" }) => {
    const useSwiper = topSolar.length >= 3;

    const imageStyle = {
        width: "100%",
        height: "440px",
        objectFit: "contain",
        backgroundColor: "#f8f9fa"
    };

    return (
        <section className="py-5 border-top overflow-hidden px-2" style={{ background: '#E5E7EB' }}>
            <Container>
                <div className="position-relative mb-3 text-center">
                    <h2 className="textRes" style={{ color: "#000", textTransform: 'uppercase' }}>
                        {heading} <span style={{ color: '#a20000' }}>{subHeading}</span>
                    </h2>
                </div>

                {/* Single unified card wrapping both halves, so image + list read as one block */}
                <div
                    className="bg-white rounded shadow-sm mx-auto"
                    style={{ maxWidth: '1100px', overflow: 'hidden' }}
                >
                    <Row className="g-0 align-items-stretch">
                        {/* LEFT: image swiper, flush inside the shared card */}
                        <Col lg={6} md={12}>
                            <div style={{ padding: '24px' }}>
                                {useSwiper ? (
                                    <Swiper
                                        slidesPerView={1}
                                        spaceBetween={16}
                                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                                        pagination={{ clickable: true }}
                                        loop={true}
                                        modules={[Autoplay, Pagination]}
                                        className="mySwiper overflow-hidden pb-5"
                                    >
                                        {topSolar?.map((item, index) => (
                                            <SwiperSlide key={`media-${index}`}>
                                                <div style={{ borderRadius: '10px', overflow: 'hidden', border: '1px solid #eee' }}>
                                                    <img
                                                        style={imageStyle}
                                                        src={item.img}
                                                        alt={item.title}
                                                        width={800}
                                                        height={440}
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                ) : (
                                    topSolar.map((item, index) => (
                                        <div key={index} style={{ borderRadius: '10px', overflow: 'hidden', border: '1px solid #eee', marginBottom: '16px' }}>
                                            <img
                                                src={item.img}
                                                alt={item.title}
                                                style={imageStyle}
                                                width={800}
                                                height={440}
                                                loading="lazy"
                                            />
                                        </div>
                                    ))
                                )}
                            </div>
                        </Col>

                        {/* RIGHT: connected vertical list — a divider line ties each
                            entry to the one below it, and a colored accent bar on the
                            far left visually links the whole list back to the image */}
                        <Col lg={6} md={12} style={{ background: '#FAFAFA', borderLeft: '1px solid #eee' }}>
                            <div style={{ padding: '24px 28px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                {/* Real, crawlable text summary — this is what search engines
                                    and AI assistants read; the graphics alone can't be
                                    indexed as text. */}
                                <p style={{ fontSize: '14px', lineHeight: '1.7', color: '#4b5563', marginBottom: '18px' }}>
                                    Gautam Solar has been independently ranked <strong style={{ color: '#1f2937' }}>India's
                                        4th largest solar manufacturer</strong> by JMK Research &amp; Analytics,
                                    holding an <strong style={{ color: '#1f2937' }}>8% share</strong> of India's total
                                    module shipments. The company has also been recognized among <strong style={{ color: '#1f2937' }}>India's
                                        Top 10 solar  manufacturers</strong> by CRISIL's Bridge to India
                                    (India PV Module Intelligence Brief, Q4 2024), with a 3.5% share of a
                                    domestic market of approximately 12,416 MW at that time.
                                </p>

                                {topSolar.map((item, index) => (
                                    <div
                                        key={`text-${index}`}
                                        style={{
                                            display: 'flex',
                                            gap: '14px',
                                            padding: '18px 0',
                                            borderBottom: index !== topSolar.length - 1 ? '1px solid #E5E7EB' : 'none',
                                        }}
                                    >
                                        <div
                                            style={{
                                                flexShrink: 0,
                                                width: '4px',
                                                borderRadius: '4px',
                                                background: '#a20000',
                                            }}
                                        />
                                        <div>
                                            <h3
                                                className="fw-semibold mb-1"
                                                style={{ fontSize: '16px', color: '#1f2937' }}
                                            >
                                                {item.title}
                                            </h3>
                                            <p className="mb-1" style={{ fontSize: '13.5px', color: '#6b7280', lineHeight: '1.6' }}>
                                                {item.desc}
                                            </p>
                                            {item.source && (
                                                <p className="mb-0" style={{ fontSize: '12px', color: '#a20000', fontWeight: 600 }}>
                                                    Source: {item.source}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    );
};

export default AmongTopSolar;